import React, {Component} from 'react';
import ListingContainer from "../../../containers/listing_container";
import {Button, Form, Grid, Header, Label, Segment} from "semantic-ui-react";
import {AGENT_API_URL, COMPANY_API_URL} from "../../../constants/api_routes";
import {getListingData} from "../../../data/user_api";

class UpdateAgentUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            companyListOptions: [],
            companyId: undefined,
            companyValid: true,
            showLogo:this.props.selectedObject[0]['show_logo']
        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        if (!this.state.companyId) {
            this.setState({companyValid: false});
            return;
        }
        else {
            formData.append("company_id", this.state.companyId);
        }
        formData.append("show_logo", this.state.showLogo);
        this.setState({disableSave:true});
        this.props.updateDetails(AGENT_API_URL, formData, this.props.selectedObject[0].id, this.successCallback);
    };

    componentWillMount() {
        this.getCompanyList().then(() => {
            this.setState({companyId: this.props.selectedObject[0]['company_id']})
        });
    }

    successCallback = (response) => {
        if (response['agent_profile'] || response.success) {
            this.props.onSuccess();
        }
    };

    getCompanyList = async () => {
        const companyList = await getListingData(COMPANY_API_URL);
        let companyOptions = [];
        for (let i = 0; i < companyList.length; i++) {
            let obj = {
                key: companyList[i].id,
                text: companyList[i].name,
                value: companyList[i].id
            };
            companyOptions.push(obj);
        }
        this.setState({companyListOptions: companyOptions});
    };

    render() {
        const currentEditingUser = this.props.selectedObject[0];
        return (
            <div>
                <Header as='h2' textAlign='center'>
                    Update Agent User
                </Header>

                <Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Column width={8}>
                            <Segment className='segment-width'>
                                <Label color='blue' ribbon>
                                    Profile Details
                                </Label>
                                <p></p>
                                <p style={{fontWeight: 600, fontSize: '1.3rem'}}>Email: <span
                                    style={{fontWeight: 200}}>{currentEditingUser.email}</span>
                                </p>
                                <Form.Input label='Name' fluid icon='user' iconPosition='left' placeholder='Name'
                                            type='text' name="name" defaultValue={currentEditingUser.name}
                                            required/>
                                <Form.Input label='Mobile Number' fluid icon='mobile' iconPosition='left'
                                            placeholder='328659286'
                                            type='text' name="mobile_number"
                                            defaultValue={currentEditingUser['mobile_number']}
                                            required/>
                                <Form.Group widths={2} className="field">
                                <Form.Dropdown
                                    label='Company Name'
                                    required
                                    search
                                    noResultsMessage="Company not found"
                                    error={!this.state.companyValid}
                                    selection
                                    wrapSelection={false}
                                    options={this.state.companyListOptions}
                                    placeholder='Company Name'
                                    value={this.state.companyId}
                                    onFocus={()=>this.setState({companyValid:true})}
                                    onChange={(e, option) => {
                                        this.setState({companyId: option.value});
                                    }}
                                /> <Form.Dropdown
                                label='Show Logo in PDF'
                                required
                                selection
                                wrapSelection={false}
                                options={[{key:"1",text:"Yes",value:true},{key:"2",text:"No",value:false}]}
                                placeholder='Choose...'
                                value={this.state.showLogo}
                                    onChange={(e, option) => {
                                        this.setState({ showLogo: option.value });
                                }}
                            /></Form.Group>
                                <Form.Group widths={2} className="field">
                                    <Form.TextArea label="Send Invoice To" fluid icon='at' iconPosition='left'
                                                placeholder='user@abc.com' defaultValue={currentEditingUser['invoice_email']}
                                                type='text' name="invoice_email"/>
                                    <Form.TextArea label="Send Report To" fluid icon='at' iconPosition='left'
                                                placeholder='user@report.com' defaultValue={currentEditingUser['report_email']}
                                                type='text' name="report_email"/>
                                </Form.Group>

                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Address Details
                                </Label>
                                <p></p>
                                <Form.Input label='Address Line 1'
                                            fluid
                                            placeholder='Street'
                                            type='text'
                                            name="line1"
                                            defaultValue={currentEditingUser.line1}
                                            required
                                />
                                <Form.Input label='Address Line 2'
                                            fluid
                                            placeholder='Landmark'
                                            type='text'
                                            name="line2"
                                            defaultValue={currentEditingUser.line2}
                                            required
                                />
                                <Form.Group widths={2}>
                                    <Form.Input label='Address Locality'
                                                fluid
                                                placeholder='Region'
                                                type='text'
                                                name="locality"
                                                defaultValue={currentEditingUser.locality}
                                    />
                                    <Form.Input label='City'
                                                fluid
                                                placeholder='City'
                                                type='text'
                                                name="city"
                                                defaultValue={currentEditingUser.city}
                                    />
                                </Form.Group>
                                <Form.Group widths={2} className='field'>
                                    <Form.Input label='Country'
                                                fluid
                                                placeholder='Country'
                                                type='text'
                                                name="country"
                                                defaultValue={currentEditingUser.country}
                                    />
                                    <Form.Input label='Post Code'
                                                fluid
                                                placeholder='C2PN57'
                                                type='text'
                                                name="postcode"
                                                defaultValue={currentEditingUser.postcode}
                                                required
                                    />
                                </Form.Group>
                            </Segment>
                        </Grid.Column>
                        <div className="submit-buttons">
                            <Button primary fluid disabled={this.state.disableSave}>Update User</Button>
                        </div>
                    </Grid>
                </Form>
            </div>
        );
    }

}

export default ListingContainer(UpdateAgentUser);


// WEBPACK FOOTER //
// ./src/views/user/agent/update_user.js